export default "__VITE_ASSET__CVktkf$S__"